/** @jsxImportSource @emotion/react */
'use client';

import React from 'react';
import { IconSlot, InputWrapper, StyledInput } from './styled';
import type { InputProps } from './types';

export const Input = React.forwardRef<HTMLInputElement, InputProps>(
  (
    {
      variant = 'default',
      size = 'md',
      hasError = false,
      disabled = false,
      fullWidth = true,
      leftIcon,
      rightIcon,
      className,
      testId = 'input',
      css,
      style,
      ...rest
    },
    ref
  ) => {
    const hasLeftIcon = Boolean(leftIcon);
    const hasRightIcon = Boolean(rightIcon);

    return (
      <InputWrapper $fullWidth={fullWidth} className={className} style={style}>
        {hasLeftIcon ? (
          <IconSlot $side="left" aria-hidden="true">
            {leftIcon}
          </IconSlot>
        ) : null}
        <StyledInput
          ref={ref}
          $variant={variant}
          $size={size}
          $hasError={hasError}
          $fullWidth={fullWidth}
          $hasLeftIcon={hasLeftIcon}
          $hasRightIcon={hasRightIcon}
          disabled={disabled}
          data-testid={testId}
          data-variant={variant}
          data-error={hasError || undefined}
          aria-invalid={hasError || undefined}
          css={css}
          {...rest}
        />
        {hasRightIcon ? (
          <IconSlot $side="right" aria-hidden="true">
            {rightIcon}
          </IconSlot>
        ) : null}
      </InputWrapper>
    );
  }
);

Input.displayName = 'Input';
